"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendToDatadog = sendToDatadog;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _browserLogs = require("@datadog/browser-logs");
var _getURLPathParams = require("../getURLPathParams");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {string} loggerName
 * @param {{}} payload
 * @param {string | undefined} message
 * @param {boolean} isError
 */
function sendToDatadog(loggerName, payload) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var messageContext = _objectSpread({
    logger: {
      name: loggerName
    }
  }, payload);
  var params = (0, _getURLPathParams.getURLPathParams)();
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    var paramType = key.replace('Id', '');
    var messageKey = "studio.".concat(paramType, ".id");
    messageContext[messageKey] = val;
  });
  var method = isError ? 'error' : 'info';
  _browserLogs.datadogLogs.logger[method](message, messageContext);
}